export default "__VITE_ASSET__DcnnybKt__"